import { useCallback, useState } from "react";

export function useProjectNameEditing(projectName: string, setProjectName: (v: string) => void) {
    const [isEditingName, setIsEditingName] = useState(false);

    const startEditingName = useCallback(() => setIsEditingName(true), []);
    const cancelEditingName = useCallback(() => setIsEditingName(false), []);

    const commitProjectName = useCallback(
        (newName: string) => {
            const trimmed = newName.trim();
            if (trimmed) setProjectName(trimmed);
            setIsEditingName(false);
        },
        [setProjectName],
    );

    return { isEditingName, startEditingName, cancelEditingName, commitProjectName };
}
